import * as React from 'react'

import { useAsyncData } from 'modules/core/hooks/useAsyncData'

import SurveyForm from 'modules/surveys/store/models/v2/Survey'

export function useSurvey(formId: string | undefined): {
  loading: boolean
  survey: SurveyForm | undefined
} {
  const [survey, setSurveyForm] = React.useState<SurveyForm>()

  const { loading } = useAsyncData(async () => {
    if (!formId) return

    const survey = await SurveyForm.fetch({ id: formId })
    setSurveyForm(survey)
  }, [formId])

  return {
    loading,
    survey,
  }
}
